<template>
    <div class="pricelist-modal">
        <h3 class="map-modal__title">{{ title }}</h3>
        <h5 class="mb-5 text-title">
            {{ "map.price_law" | trans }}
        </h5>
        <div class="map-modal__content flex flex-col md:flex-row">
            <table
                class="map-modal__info-table"
                v-if="workTime || phone || tollTrack"
            >
                <tr v-if="workTime">
                    <td>{{ "map.work_time" | trans }}:</td>
                    <td>{{ workTime }}</td>
                </tr>
                <tr v-if="phone">
                    <td>{{ "map.phone_number" | trans }}:</td>
                    <td>{{ phone }}</td>
                </tr>
                <tr v-if="tollTrack">
                    <td>{{ "map.toll_track" | trans }}:</td>
                    <td>{{ tollTrack }}</td>
                </tr>
            </table>

            <img
                src="/images/map/enc-nadoplata.png"
                alt="enc-nadoplata"
                class="map-modal__enc-img"
                v-if="enc_fill"
            />
        </div>
        <div class="map-modal__content" v-if="!prices.length">
            {{ content }}
        </div>
        <div class="map-modal__table" v-if="prices.length">
            <table>
                <thead>
                    <tr>
                        <th>{{ "map.exit_station" | trans }}</th>
                        <th v-for="vehicle in vehicleCategory" :key="vehicle">
                            {{ `map.${vehicle}` | trans }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(price, i) in reversePrices" :key="price.exit">
                        <td>{{ price.exit }}</td>
                        <td class="py-2">
                            {{ price.category_IA }} {{ mainCurrencySymbol }}
                        </td>
                        <td class="py-2">
                            {{ price.category_I }} {{ mainCurrencySymbol }}
                        </td>
                        <td class="py-2">
                            {{ price.category_II }} {{ mainCurrencySymbol }}
                        </td>
                        <td class="py-2">
                            {{ price.category_III }} {{ mainCurrencySymbol }}
                        </td>
                        <td class="py-2">
                            {{ price.category_IV }} {{ mainCurrencySymbol }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "./../axios.js";
import Vue from "vue";

export default {
    props: {
        title: {
            type: String,
        },
        content: {
            type: String,
            default: "",
        },
        initialPrices: {
            default: () => [],
        },
        tollId: {
            default: null,
        },
        workTime: {
            default: "-",
        },
        tollTrack: {
            default: "-",
        },
        phone: {
            default: "-",
        },
        enc_fill: {
            default: false,
            type: Boolean,
        },
    },
    data() {
        return {
            prices: this.initialPrices,
            mainCurrency: "EUR",
            mainCurrencySymbol: "€",
        };
    },
    mounted() {
        if (!this.prices.length) {
            this.getPrices();
        }
    },
    methods: {
        getPrices() {
            let url = `${this.url}/toll-places/${this.tollId}`;
            axios
                .get(url)
                .then((res) => {
                    Vue.set(this, "prices", res.data.prices);
                    Vue.set(this, "mainCurrency", res.data.main_currency);
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                });
        },
    },
    computed: {
        ...mapGetters(["vehicleCategory", "url"]),

        reversePrices() {
            return this.prices;
        },
    },
    watch: {
        tollId(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getPrices();
            }
        },
    },
};
</script>
